let vueformPromise = null

// Shared loader so the router can start the download alongside the route chunk
// and everything else (views, Sentry) awaits the same in-flight import.
export function loadVueform() {
  if (!vueformPromise) {
    vueformPromise = import('./lazyVueform')
  }
  return vueformPromise
}
